import { CommonModule, NgFor, NgIf, DOCUMENT } from '@angular/common';
import {
  Component,
  Input,
  HostListener,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { AuthenticationService } from '../../_services/authentication.service';
import { DatasearchService } from '../../_services/datasearch.service';
import { GlobalService } from '../../_services/global.service';
import * as bootstrap from 'bootstrap';
import { BusyService } from '../../_services/busy.service';
import md5 from 'md5';
import { AppLinks } from '../../app-links';
// import { RecaptchaModule } from 'ng-recaptcha';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js'; // @ts-ignore
import { RecaptchaModule, ReCaptchaV2Component } from 'ng-recaptcha';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
declare var $: any;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    DropdownModule,
    NgIf,
    CommonModule,
    RouterLink,
    NgFor,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    ToastModule,
    TooltipModule,
  ],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Input() transparent: boolean = false;
  @Input() homePage: boolean = false;
  @ViewChild('recaptchaRef') recaptchaRef!: ReCaptchaV2Component;
  @ViewChild('userSettingDialog') userSettingDialog!: ElementRef;
  lists: any = [];
  labels: { id: number; profession: string; checked: boolean }[] = [];
  ids: number[] = [];
  signInForm: FormGroup = this.fb.group({});
  forgotPasswordForm: FormGroup = this.fb.group({});
  demorequestForm: FormGroup = this.fb.group({});
  signUpForm: FormGroup = this.fb.group({});
  accessKey: string = '';
  selectedCountsignup: number = 0;
  selectedCountdemo: number = 0;
  languages: any[] = []; // Define languages array
  selectedLanguage: any = {};
  errorMessage: string = '';
  showSecondForm: boolean = false;
  showProducts = false;
  descDropdown = false;
  servicesDropdown = false;
  overAgroProducts = false;
  overProductsDropdown = false;
  overHeaderDesc = false;
  overDescDropdown = false;
  overHeaderservices = false;
  overServicesDropdown = false;
  showMenu = false;
  selectedMenu = '';
  headerData: any = {};
  successMessage: string = '';
  countries: any[] = [];
  originalCountries: any[] = [];
  details = ['Profession', 'Professional Detail', 'Personal Detail'];
  showThirdForm: boolean = false;
  showWarn: boolean = false;
  isSignedIn = false;
  isLoggedIn: boolean = false;
  public appLinks = AppLinks;
  sentEmail: string = '';
  errorMessageforgot: string = '';
  isSubmitted: boolean = false;
  dropdownOpen = false;
  userSetting = false;
  selectedBrochure: any;
  brochures: any[] = [];
  recaptchaResponse: string | null = null;
  formSubmitted = false;
  user_ip: string = '';
  address: string = '';

  // errorMessage: string = '';
  // countries: any[] = [];
  // successMessage: string = '';
  logoUrl = 'https://www.chemrobotics.com/agropat/uploads/thumbnail/';

  recaptchaSiteKey = '6Leb26MqAAAAAMWLVC6Br0ORCeLt7zeLl0aJM-3B'; // live
  // recaptchaSiteKey = '6Lcpo3QqAAAAAIKDJyb4lg4QKCWMuQMA7VxbP9uD'; // local
  userData: any = {};
  verticals: { vertical: string; checked: boolean }[] = [
    { vertical: 'AgroPat Ultimate Discovery Suite', checked: false },
    { vertical: 'AgroPat Ultimate Generic Suite', checked: false },
    { vertical: 'Technical Route', checked: false },
    { vertical: 'ChemiTracker - A Supplier Guide', checked: false },
    { vertical: 'Global MRL Database', checked: false },
    { vertical: 'QuikPatent - Constraining Patent Guide', checked: false },
    { vertical: 'Indian Pesticide Database', checked: false },
    { vertical: 'Global Agro Product Directory', checked: false },
    { vertical: 'Company Directory', checked: false },
    { vertical: 'PharmVetPat Ultimate', checked: false },
    { vertical: 'AgroPharm XIM DB Beta', checked: false },
    { vertical: 'Supplementary Protection Certificate', checked: false },
  ];
  copyMessage: string | undefined;

  constructor(
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private datasearch: DatasearchService,
    private globalService: GlobalService,
    private router: Router,
    private busyService: BusyService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {
    this.initialiseForm();
    this.setIpandLocation();
  }

  ngOnInit() {
    this.logoUrl = this.datasearch.constants ? this.datasearch.constants.ApiUrl + '/uploads/layout-logos/' : 'http://localhost:5001/uploads/layout-logos/';
    this.checkUser();
    this.getHeaderData();
    this.globalService.getOpenSignInModal().subscribe((val) => {
      val ? this.openSignInForm() : '';
    });
    this.globalService.getOpenSignUpModal().subscribe((val) => {
      val ? this.openSignUpForm() : '';
    });
    this.authenticationService.getLoginUser().subscribe((val) => {
      this.isSignedIn = val;
    });
    this.authenticationService.getCurrentUserValue().subscribe((val: any) => {
      this.userData = val;
      console.log("----------------------",this.userData);

    });

    setTimeout(() => {
      this.onWindowScroll();
    }, 0);
    // this.updateCount();
    this.getLabels();
    // this.initialiseForm();11`
    this.updateSelectedCount();
    // this.getLanguages(); // Load languages data
    //  this.loadGoogleTranslate();
    this.getList();
    this.loadCountryCodes();
    this.getBrochureData();
  }
  ngAfterViewInit() {
    this.loadGoogleTranslate();
  }

  loadCountryCodes() {
    const uniqueCountries = new Map();
    getCountries().forEach((country) => {
      const code = `+${getCountryCallingCode(country)}`;
      const flag = `https://flagcdn.com/16x12/${country.toLowerCase()}.png`;
      if (!uniqueCountries.has(code)) {
        uniqueCountries.set(code, { code, flag });
      }
    });
    this.countries = Array.from(uniqueCountries.values());
  }
  checkUser() {
    const searchParams = new URLSearchParams(window.location.search);
    this.accessKey = searchParams.get('access_key') || this.route.snapshot.queryParams['access_key'] || '';

    // If access_key is present in the URL, prioritize fresh auto-login immediately
    if (this.accessKey != '') {
      const autoLoginCall = (this.authenticationService.auto_login2 ? this.authenticationService.auto_login2(this.accessKey) : this.authenticationService.auto_login(this.accessKey));
      autoLoginCall.subscribe(
        (res: any) => {
          if (res && res.status !== false && res.status !== 'false' && (res.token || res.userid || res.status === true)) {
            const url = new URL(window.location.href);
            url.searchParams.delete('access_key');
            window.location.href = url.pathname + url.search;
          } else {
            console.log('Auto login failed or inactive:', res);
          }
        },
        (error: any) => {
          console.log('Auto login error:', error);
        }
      );
      return;
    }

    let currentuser = localStorage.getItem('currentUser');
    if (currentuser) {
      this.authenticationService.refreshToken().subscribe(
        (val: any) => {
          if (this.authenticationService.getSavedUser) this.authenticationService.getSavedUser();
          this.isLoggedIn = true;
        },
        (err: any) => {
          console.log(err);
          if (err.statusText === 'Unauthorized' || err.status === 401 || err.status === 403) {
            localStorage.removeItem('currentUser');
            this.authenticationService.sendCurrentUserSubject({});
            this.authenticationService.sendLoginUser(false);
          }
        }
      );
      let currentUser2 = JSON.parse(currentuser);
      if (currentUser2 != null && currentUser2.userid) {
        this.accessKey = btoa(currentUser2.userid);
      }
    }
  }

  loadGoogleTranslate() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      function googleTranslateElementInit() {
        new google.translate.TranslateElement({pageLanguage: 'en'}, 'google_translate_element');
      }
      googleTranslateElementInit();
    `;
    // document.head.appendChild(script);
  }

  getList() {
    this.lists = [
      'ChemRobotics offers Trial access to users who wish to evaluate ChemRobotics database. Its important to note that ChemRobotics is a premium Database that requires a paid subscription.',
      'According to ChemRobotics Database policy, we kindly request users to register using their official Company Domain email. We regret to inform you that personal email providers such as Gmail, Yahoo and Rediff etc., are not accepted for the Sign-Up process.',
      'To ensure an ideal experience, we kindly ask users to provide accurate and complete details during the Sign-Up process. ChemRobotics support team reviews the information provided. If any incorrect, false, or incomplete information is found, the user may not be granted activation for ChemRobotics trial access.',
      'Once the user has successfully completed the signup process, ChemRobotics support team will review the registration details. Based on their evaluation, the user will receive an activation email directly from ChemRobotics support team.',
    ];
  }

  initialiseForm() {
    this.signInForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.demorequestForm = this.fb.group({
      verticals: [''], // No validators for this, set dynamically
      date: ['', Validators.required],
      time: ['', Validators.required],
      fname: ['', Validators.required],
      lname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      country_code: ['+91', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      job: ['', Validators.required],
      company: ['', Validators.required],
      country: ['', Validators.required],
      industry: ['', Validators.required],
      comment: [''],
      web: ['Agro'],
      source: [''],
      recaptcha: ['', Validators.required],
    });
    this.signUpForm = this.fb.group({
      address: ['', Validators.required],
      // company_email_id: ['', [Validators.required, Validators.email]],
      company_name: ['', Validators.required],
      // country_code: ['+91', Validators.required],
      country_name: ['', Validators.required],
      gender: ['', Validators.required],
      department_name: ['', Validators.required],
      education: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      firstname: ['', Validators.required],
      industry: ['', Validators.required],
      institute_company: ['', Validators.required],
      lastname: ['', Validators.required],
      mobile_no: ['', [Validators.required]],
      notify_update: ['true', Validators.required],
      occupation: ['', Validators.required],
      password: ['', [Validators.required]],
      pincode: ['', Validators.required],
      state: ['', Validators.required],
      prefix: ['', Validators.required],
      scientific_profession: [[]],
      // recaptcha: ['', Validators.required],
      web: ['Agro'],
    });
  }

  LogoutClick() {
    this.authenticationService.logout();
    this.userSetting = false;
    this.accessKey = '';
    this.selectedMenu = '';
    this.isLoggedIn = false;
    const currentRoute = this.router.url;
    this.router.navigate(['/']);
    if (currentRoute === '/profile' || currentRoute === '/edit_profile') {
      this.router.navigate(['/']);
    }
  }
  // getLabels() {
  //   this.datasearch.getUserprofession().subscribe(
  //     (res) => {
  //       this.labels = res.data.map((item: any) => ({ id: item.id, profession: item.profession, checked: false }));
  //       this.ids = res.data.map((item: any) => item.id);
  //     },
  //     (err) => {
  //       console.error('Error fetching user profession data', err);
  //     }
  //   );
  // }
  onBrochureChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const selectedBrochure = target.value;
    if (selectedBrochure) {
      window.open(selectedBrochure, '_blank');
    }
  }
  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  toggleUserSetting(event: MouseEvent): void {
    event.stopPropagation();
    this.userSetting = !this.userSetting;
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = document.querySelector(
      '.header_top_left_box1_item_icon1_dropdown'
    );
    const toggle = document.querySelector('.selected-option');

    // Check if the dropdown exists and if the click is outside the dropdown or toggle
    if (
      dropdown &&
      !dropdown.contains(target) &&
      toggle &&
      !toggle.contains(target)
    ) {
      this.dropdownOpen = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (
      this.userSetting &&
      this.userSettingDialog &&
      !this.userSettingDialog.nativeElement.contains(event.target)
    ) {
      this.userSetting = false;
    }
  }

  getBrochureData() {
    this.datasearch.getBrochure().subscribe(
      (res) => {
        const list = res?.data || res?.results;
        if (list && Array.isArray(list)) {
          this.brochures = list.map((brochure: any) => ({
            id: brochure._id || brochure.id,
            fileName: brochure.file_name || brochure.fileName || brochure.title || 'Unknown Brochure',
            brochureUrl: brochure.brochureUrl || brochure.url || (brochure.brochure ? `https://www.chemrobotics.com/agropat/uploads/brochures/${brochure.brochure}` : '#'),
          }));
        }
      },
      (error) => {
        console.error('Error fetching brochures: ', error);
      }
    );
  }

  selectBrochure(brochure: any) {
    this.selectedBrochure = brochure;
    this.dropdownOpen = false;

    // Open the selected brochure in a new tab
    if (brochure.brochureUrl) {
      window.open(brochure.brochureUrl, '_blank');
    } else {
      console.error('Invalid brochure URL');
    }
  }

  getHeaderData() {
    this.datasearch.getHeader().subscribe(
      (res) => {
        if (res && (res.success || res.status)) {
          this.headerData = Array.isArray(res.data) ? res.data[0] : res.data;
        }
      },
      (error) => {
        console.error('Error fetching header data', error);
      }
    );
  }
  submitForgotPasswordForm() {
    if (this.forgotPasswordForm.valid && this.recaptchaResponse) {
      this.formSubmitted = true;
      const email = this.forgotPasswordForm.get('email')?.value;
      this.sentEmail = email;
      const formData = new FormData();
      formData.append('username', email);
      formData.append('web', 'Agro');
      this.busyService.busy();
      this.datasearch.sendForgotpswd(formData).subscribe(
        (response) => {
          this.busyService.idle();
          this.formSubmitted = false;
          this.forgotmodelclose();
          if (response.status === 'success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Check Email',
              detail: response.message,
              life: 10000,
            });
            // this.showAlertModal();
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: response.message,
              life: 10000,
            });
          }
        },
        (error) => {
          this.busyService.idle();
          this.errorMessageforgot =
            'An error occurred while sending the request.';
        }
      );
    } else {
      this.errorMessageforgot = 'Please provide a valid email address.';
    }
  }

  forgotmodelclose() {
    const modalElement = document.getElementById('forgot-password');
    if (modalElement) {
      $('#forgot-password').modal('hide');
    }
  }

  showAlertModal() {
    const alertModalElement = document.getElementById('alertModelforgot');
    if (alertModalElement) {
      $('#alertModelforgot').modal('show');
      setTimeout(() => {
        $('#alertModelforgot').modal('hide');
      }, 5000); // Close the alert modal after 5 seconds
    }
  }
  // // sign-up
  // updateCount() {
  //   this.selectedCountsignup = this.labels.filter(profession => profession.checked).length;
  // }

  // toggleCheckbox(index: number) {
  //   this.labels[index].checked = !this.labels[index].checked;
  //   this.updateCount();
  // }

  // demo
  // toggleSecondForm() {
  //   this.signUpForm.controls['scientific_profession'].setValue(this.labels.filter(val => val.checked).map(val => val.id));
  //   this.showSecondForm = !this.showSecondForm;
  // }

  // isNextButtonEnabled() {
  //   return this.selectedCountsignup > 0;
  // }

  // toggleThirdForm() {
  //   this.showThirdForm = !this.showThirdForm;
  // }
  openInNewTab(url: string): void {
    window.open(url, '_blank');
  }
  // openSignUpForm() {
  //   const modalElement = document.getElementById('sign-up');
  //   if (modalElement) {
  //     const modalInstance = new bootstrap.Modal(modalElement);
  //     if (modalInstance) {
  //       modalInstance.show();
  //     }
  //   }
  //   this.globalService.sendOpenSignUpModal(false);
  // }

  // submit_signup_form() {
  //   this.signUpForm.valid
  //   let postdata: any = {};
  //   postdata.data = this.signUpForm.value;
  //   this.signUpForm.controls['scientific_profession'].value;
  //   this.datasearch.sendSignup(postdata).subscribe(
  //     response => {
  //       console.log('Signup Successful!', response);
  //       // debugger
  //        this.closeSignUpModal();
  //     },
  //     error => {
  //       console.error('Signup Error:', error);
  //     }
  //   );
  //   this.signUpForm.reset();
  // }

  submit_signin_form() {
    if (this.signInForm.invalid) {
      this.signInForm.markAllAsTouched();
      return;
    }

    const postdata = {
      username: this.signInForm.value.username,
      password: this.signInForm.value.password,
    };
    console.log('eeeeeeeeeeeeeeeeee');
    console.log(postdata);

    this.busyService.busy();

    this.authenticationService.user_login(postdata).subscribe(
      (res) => {
        this.isLoggedIn = true;
        this.busyService.idle();
        this.isSignedIn = true;
        this.authenticationService.sendLoginUser({
          userId: res.userid || res.userId,
          username: res.username,
        });

        // Close the modal and allow background scrolling
        this.closeSignInModal();

        // Reload the page after login to automatically apply permissions to all active components
        setTimeout(() => {
          window.location.reload();
        }, 300);
      },
      (err) => {
        let rawError = err?.error?.message || err?.error?.error || (typeof err?.error === 'string' ? err?.error : null) || err?.message;
        if (typeof rawError === 'string' && rawError.includes('Http failure response')) {
          rawError = 'Access denied: Invalid credentials or account is suspended/inactive.';
        }
        this.errorMessage = rawError || 'Invalid username or password';
        this.signInForm.reset();
        this.signInForm.markAsUntouched();
        this.busyService.idle();
      }
    );
  }

  previousForm() {
    if (this.showThirdForm) {
      this.showThirdForm = false;
      this.showSecondForm = true;
    } else if (this.showSecondForm) {
      this.showSecondForm = false; // Add this line to go back to the first form
      // Optionally set a flag to show the first form if needed
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      } else {
        control?.markAsTouched();
      }
    });
  }
  // submit_signin_form() {
  //   this.signInForm.valid
  //   let postdata: any = {};
  //   postdata.username = this.signInForm.value.username;
  //   postdata.password = md5(this.signInForm.value.password);
  //   // this.busyService.busy();
  //   this.authenticationService.user_login(postdata).subscribe((res) => {
  //     // this.busyService.idle();
  //     this.isSignedIn = true;
  //     this.closeSignInModal();
  //   }, (err) => {
  //     console.log(err)
  //   });

  // }
  openSignInForm() {
    const modalElement = document.getElementById('sign-in');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();
      }
    }
    this.globalService.sendOpenSignInModal(false);
  }
  openSignUpForm() {
    const modalElement = document.getElementById('sign-up');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();
      }
    }
    this.globalService.sendOpenSignInModal(false);
  }

  closeSignInModal() {
    // const modalElement = document.getElementById('sign-in');
    // if (modalElement) {
    //   const modalInstance = bootstrap.Modal.getInstance(modalElement);
    //   if (modalInstance) {
    //     modalInstance.hide();
    //     modalInstance.dispose();
    //     // Allow background scrolling
    //     document.body.classList.remove('modal-open'); // Remove Bootstrap modal-open class
    //     document.body.style.overflow = ''; // Reset overflow style to default
    //   }
    // }

    // // Manually remove any remaining backdrop elements
    // const backdrops = document.getElementsByClassName('modal-backdrop');
    // while (backdrops.length > 0) {
    //   document.body.removeChild(backdrops[0]);
    // }
    const modalElement = document.getElementById('sign-in');
    if (modalElement) {
      // Remove the 'show' class and set the display style
      modalElement.classList.remove('show');
      modalElement.setAttribute('style', 'display: none;');
      modalElement.setAttribute('aria-hidden', 'true');

      // Get the Bootstrap modal instance
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        modalInstance.dispose();
      }

      // Allow body to scroll again
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Remove the modal-backdrop element
      let backdropElements = document.querySelectorAll('.modal-backdrop');
      backdropElements.forEach((backdrop) => {
        backdrop.remove(); // Remove each backdrop element if exists
      });
    }
  }

  // brochures = [
  //   { id: 1, title: 'Brochure 2', url: 'https://www.chemrobotics.com/agropat/assets/CHEMROBOTICS_Brochure_2020.pdf' },
  //   { id: 2, title: 'Brochure 2', url: 'https://www.chemrobotics.com/agropat/assets/CHEMROBOTICS_Brochure_2020.pdf' },
  //   { id: 3, title: 'Brochure 3', url: 'https://www.chemrobotics.com/agropat/assets/CHEMROBOTICS_Brochure_2020.pdf' },
  //   { id: 4, title: 'Brochure 4', url: 'https://www.chemrobotics.com/agropat/assets/CHEMROBOTICS_Brochure_2020.pdf' }
  // ];

  addHttpsIfMissing(url: string): string {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return 'https://' + url;
    }
    return url;
  }

  // closeSignUpModal() {
  //   const modalElement = document.getElementById('sign-up');
  //   if (modalElement) {
  //     const modalInstance = bootstrap.Modal.getInstance(modalElement);
  //     if (modalInstance) {
  //       modalInstance.hide();
  //       modalInstance.dispose();
  //     }
  //   }

  // Manually remove any remaining backdrop elements
  //   const backdrops = document.getElementsByClassName('modal-backdrop');
  //   while (backdrops.length > 0) {
  //     document.body.removeChild(backdrops[0]);
  //   }
  // }

  toggleVerticalChecked(index: number) {
    this.verticals[index].checked = !this.verticals[index].checked;
    this.selectedCountdemo = this.verticals.filter((v) => v.checked).length;
  }
  updateSelectedCount() {
    this.selectedCountdemo = this.verticals.filter(
      (vertical) => vertical.checked
    ).length;
  }
  submit_demo_form() {
    let verticalArr: any = this.verticals
      .filter((str: any) => {
        return str.checked;
      })
      .map((val: any) => {
        return val.vertical;
      });
    verticalArr = verticalArr.join();
    this.demorequestForm.controls['verticals'].setValue(verticalArr);
    // if (this.demorequestForm.valid) {
    this.demorequestForm.value.time += ':00';
    // this.busyService.busy();
    let emailPostData = {
      to: 'support@chemrobotics.com',
      cc: 'greenbookcorp@gmail.com',
      subject: 'Demo Request (Agro)',
      html: `
              <div style="background-color: #ffc702; heigth:30px; text-align: center;">
              <img src="cid:logoImg" alt="Logo">
              </div>
              <div style="background-color: #eee;">
                <p>New demo request received now!</p>                
              </div> 
              <div style="background-color: #eee;">
                <p>Name: <strong>${this.demorequestForm.value.fname} ${this.demorequestForm.value.lname}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Email: <strong>${this.demorequestForm.value.email}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Phone: <strong>${this.demorequestForm.value.phone}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Job: <strong>${this.demorequestForm.value.job}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Company: <strong>${this.demorequestForm.value.company}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Country: <strong>${this.demorequestForm.value.country}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Industry: <strong>${this.demorequestForm.value.industry}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Demo Date: <strong>${this.demorequestForm.value.date}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Demo Time: <strong>${this.demorequestForm.value.time}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Vertical/Platform: <strong>${this.demorequestForm.value.vertical}</strong></p>                
              </div>              
              <div style="background-color: #eee;">
                <p>Comment: <strong>${this.demorequestForm.value.comment}</strong></p>                
              </div>              
              <hr>
              <div style="background-color: #eee; text-align: center;">
              <p>Copyright 2023 <strong><a href="https://www.chemrobotics.com/">ChemRobotics</a></strong></p>
              <div/>`,
    };

    let postdata: any = {
      demoRequest: this.demorequestForm.value,
      emailPostData: emailPostData,
    };
    this.datasearch.demoRequest(postdata).subscribe(
      (response) => {
        this.closeDemoRequestModal();
        this.messageService.add({
          severity: 'success', // The severity of the message (success, error, info, etc.)
          summary: 'Demo Request Submitted', // Summary of the message
          detail: 'Your demo request has been successfully submitted!', // The content of the message
          life: 3000, // Duration of the toast (in milliseconds)
        });
        this.demorequestForm.reset();
        // this.toastr.success('Request sent!!!');
      },
      (error) => {
        console.log(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Submission Failed',
          detail: 'Something went wrong while submitting your request.',
          life: 3000,
        });
        // this.toastr.error(`${error}!!!`);
        // this.busyService.idle();
      }
    );
  }
  // Handle the reCAPTCHA response
  onCaptchaSuccess(token: string | null) {
    this.recaptchaResponse = token;
    this.startCaptchaResetTimer();
  }
  // Reset reCAPTCHA
  resetCaptcha() {
    this.recaptchaResponse = null;
    this.recaptchaRef.reset();
  }
  startCaptchaResetTimer() {
    setTimeout(() => {
      this.resetCaptcha();
    }, 50000); // 1 minute
  }
  closeDemoRequestModal() {
    const modalElement = document.getElementById('demo-form');

    if (modalElement) {
      // Hide the modal using jQuery
      $('#demo-form').modal('hide');

      // Ensure the modal is fully disposed and clean up
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        modalInstance.dispose(); // Dispose of the instance
      } else {
        // Fallback for manually handling if modal instance is undefined
        modalElement.classList.remove('show');
        modalElement.setAttribute('aria-hidden', 'true');
        modalElement.setAttribute('style', 'display: none;');
      }

      // Reset body overflow to allow scrolling again
      document.body.classList.remove('modal-open');
      document.body.style.overflow = ''; // Reset overflow style
      document.body.style.paddingRight = ''; // Reset padding-right for scroll

      // Forcefully remove the modal backdrop (if present)
      let backdropElements = document.querySelectorAll('.modal-backdrop');
      backdropElements.forEach((backdrop) => {
        backdrop.remove(); // Remove each backdrop element
      });
    }
  }

  openSignup() {
    this.getLabels();
  }
  getLabels() {
    this.datasearch.getUserprofession().subscribe(
      (res) => {
        this.labels = res.data.map((item: any) => ({
          id: item.id,
          profession: item.profession,
          checked: false,
        }));
        this.ids = res.data.map((item: any) => item.id);
      },
      (err) => {}
    );
  }

  // sign-up
  updateCount() {
    this.selectedCountsignup = this.labels.filter(
      (profession) => profession.checked
    ).length;
  }
  toggleCheckbox(index: number) {
    this.labels[index].checked = !this.labels[index].checked;
    this.updateCount();
  }

  toggleSecondForm() {
    this.signUpForm.controls['scientific_profession'].setValue(
      this.labels.filter((val) => val.checked).map((val) => val.id)
    );
    this.showSecondForm = !this.showSecondForm;
  }

  isNextButtonEnabled() {
    return this.selectedCountsignup > 0;
  }
  toggleThirdForm() {
    this.isSubmitted = true;
    if (this.showSecondForm) {
      this.signUpForm.controls['scientific_profession'].setValue(
        this.labels.filter((val) => val.checked).map((val) => val.id)
      );
      if (
        this.signUpForm.get('institute_company')?.valid &&
        this.signUpForm.get('department_name')?.valid &&
        // this.signUpForm.get('company_email_id')?.valid &&
        this.signUpForm.get('industry')?.valid &&
        this.signUpForm.get('company_name')?.valid &&
        this.signUpForm.get('occupation')?.valid &&
        this.signUpForm.get('country_name')?.valid &&
        this.signUpForm.get('state')?.valid &&
        this.signUpForm.get('address')?.valid &&
        this.signUpForm.get('pincode')?.valid
      ) {
        this.showSecondForm = false;
        this.showThirdForm = true;
        this.isSubmitted = false;
      } else {
        this.signUpForm.markAllAsTouched();
      }
    } else if (this.showThirdForm) {
      if (this.signUpForm.valid) {
        // console.log('Third form is valid');
      } else {
        this.signUpForm.markAllAsTouched();
      }
    }
  }

  // submit_signup_form() {
  //   this.isSubmitted = true;
  //   if (this.signUpForm.valid) {
  //     const postData = this.signUpForm.value;
  //     console.log('Form Data:', postData);
  //     this.datasearch.sendSignup(postData).subscribe(
  //       response => {
  //         console.log('Signup Successful!', response);
  //         this.successMessage = 'Thank you for registering with ChemRobotics'; // Set success message
  //         this.signUpForm.reset(); // Reset form after successful submission
  //         this.isSubmitted = false; // Reset submission state
  //         this.authenticationService.sendCurrentUserSubject(response); // Update the current user data
  //         this.router.navigate(['/']).then(() => {
  //           console.log('Successfully redirected to home page');
  //         }).catch(err => {
  //           console.error('Navigation Error:', err);
  //         });
  //       },
  //       error => {
  //         console.error('Signup Error:', error);
  //         this.errorMessage = "An error occurred during signup. Please try again.";
  //       }
  //     );
  //   } else {
  //     this.signUpForm.markAllAsTouched();
  //     this.errorMessage = "Please fill in all required fields correctly.";
  //     console.log('Form Errors:', this.signUpForm.errors);
  //   }
  // }

  submit_signup_form() {
    this.isSubmitted = true;

    // Show busy indicator
    this.busyService.busy();

    // Check if the form is valid and if reCAPTCHA has a response
    if (this.signUpForm.valid && this.recaptchaResponse) {
      // const formData = new FormData();
      let postData = null;

      // Append each form control value to FormData (excluding scientific_profession for now)
      postData = this.signUpForm.value;
      // formData.append(postData)
      // Object.keys(this.signUpForm.controls).forEach(control => {
      //   if (control !== 'scientific_profession') {
      //     formData.append(control, this.signUpForm.get(control)?.value);
      //   }
      // });

      // Include selected scientific professions if any
      // const selectedProfessions = this.labels
      //   .filter(val => val.checked)
      //   .map(val => val.id);

      // Append scientific_profession only once
      // formData.append('scientific_profession', JSON.stringify(selectedProfessions));

      // Simulate an API call
      this.datasearch.sendSignup(postData).subscribe(
        (response) => {
          // Hide busy indicator
          this.busyService.idle();

          // Handle success response
          if (response.status == 'error') {
            alert(response.message);
          } else {
            this.successMessage = 'Thank you for registering with ChemRobotics';
            this.router.navigate(['/']); // Navigate to the home page
            this.signUpForm.reset(); // Reset the form
            this.isSubmitted = false; // Reset submission state
            // this.resetCaptcha(); // Reset the reCAPTCHA
            this.closeSignUpModal(); // Close the modal
            this.authenticationService.sendCurrentUserSubject(response); // Send user data
          }
        },
        (error) => {
          // Hide busy indicator
          this.busyService.idle();

          // Handle errors in the response
          if (error.error && error.error.message) {
            this.errorMessage = error.error.message; // Display backend error message
          } else {
            this.errorMessage =
              'An unexpected error occurred. Please try again later.';
          }

          // Optionally, you could reset the form or perform other actions
          console.log('abc', error.message);
          if (error.status == 'error') {
            console.log('123', error.status);
          }
          this.signUpForm.reset(); // Reset the form if needed
          this.signUpForm.markAsUntouched(); // Mark all fields as untouched to reset validation states
        }
      );
    } else {
      // Hide busy indicator if form is invalid or reCAPTCHA is not filled
      this.busyService.idle();

      // Mark all fields as touched to show validation errors if form is invalid or reCAPTCHA is not filled
      this.signUpForm.markAllAsTouched();
      this.errorMessage = this.getErrorMessages(); // Get specific error messages
    }
  }

  getErrorMessages() {
    let errorMessages = '';

    Object.keys(this.signUpForm.controls).forEach((key) => {
      const controlErrors = this.signUpForm.get(key)?.errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((errorKey) => {
          errorMessages += `${key}: ${errorKey} error\n`; // Customize error messages per field
        });
      }
    });

    return (
      errorMessages ||
      'Please fill in all required fields correctly and complete reCAPTCHA.'
    );
  }

  closeSignUpModal() {
    const modalElement = document.getElementById('sign-up');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        modalInstance.dispose();
        // Allow background scrolling
        document.body.classList.remove('modal-open'); // Remove Bootstrap modal-open class
        document.body.style.overflow = ''; // Reset overflow style to default
      }
    }

    // Manually remove any remaining backdrop elements
    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      document.body.removeChild(backdrops[0]);
    }
    window.location.reload();
  }
  // onCaptchaSuccess(token: string) {
  //   console.log('reCAPTCHA resolved with token:', token);
  //   this.signUpForm.get('recaptcha')?.setValue(token); // Set the token in the form control
  // }
  enterHeader() {
    this.overProductsDropdown = true;
    this.showDropdown();
  }

  leaveHeader() {
    this.overProductsDropdown = false;
    setTimeout(() => {
      this.hideDropdown();
    }, 10);
  }

  toggleHeader() {
    this.overProductsDropdown = !this.overProductsDropdown;
    console.log('Dropdown toggle state:', this.overProductsDropdown);

    if (this.overProductsDropdown) {
      this.showDropdown();
    } else {
      this.hideDropdown();
    }
  }
  enterProductBox() {
    this.overAgroProducts = true;
    this.showDropdown();
  }

  leaveProductBox() {
    this.overAgroProducts = false;
    setTimeout(() => {
      this.hideDropdown();
    }, 10);
  }

  showDropdown() {
    this.showProducts = true;
  }
  atLeastOneCheckboxRequired(formArray: FormArray) {
    const isChecked = formArray.controls.some((control) => control.value);
    return isChecked ? null : { atLeastOneCheckboxRequired: true };
  }
  hideDropdown() {
    if (!this.overProductsDropdown && !this.overAgroProducts) {
      this.showProducts = false;
    }
  }

  enterHeaderDesc() {
    this.overHeaderDesc = true;
  }

  leaveHeaderDesc() {
    this.overHeaderDesc = false;
  }

  enterDescBox() {
    this.overDescDropdown = true;
  }

  leaveDescBox() {
    this.overDescDropdown = false;
  }

  enterHeaderServices() {
    this.overHeaderservices = true;
  }

  leaveHeaderServices() {
    this.overHeaderservices = false;
  }

  enterServicesBox() {
    this.overServicesDropdown = true;
  }

  leaveServicesBox() {
    this.overServicesDropdown = false;
  }
  copyLink() {
    const fixedLink = 'https://www.chemrobotics.com/registration'; // Fixed link
    navigator.clipboard
      .writeText(fixedLink)
      .then(() => {
        alert('Link copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });
  }
  copyToClipboarddemo() {
    const fixedUrl = 'https://www.chemrobotics.com/demo_request'; // Replace with the URL you want to copy
    navigator.clipboard
      .writeText(fixedUrl)
      .then(() => {
        this.copyMessage = 'The URL has been copied to your clipboard.'; // Update the message for the toast
        const copyToast = document.getElementById('copyToast');
        if (copyToast) {
          copyToast.classList.remove('hide');
          copyToast.classList.add('show');

          // Hide the toast after a few seconds
          setTimeout(() => {
            copyToast.classList.remove('show');
            copyToast.classList.add('hide');
          }, 3000); // Show for 3 seconds
        }
      })
      .catch((err) => {
        console.error('Failed to copy the URL: ', err);
      });
  }
  copyToClipboardsignup() {
    const fixedUrl = 'https://www.chemrobotics.com/registration'; // Replace with the URL you want to copy
    navigator.clipboard
      .writeText(fixedUrl)
      .then(() => {
        this.copyMessage = 'The URL has been copied to your clipboard.'; // Update the message for the toast
        const copyToast1 = document.getElementById('copyToast1');
        if (copyToast1) {
          copyToast1.classList.remove('hide');
          copyToast1.classList.add('show');

          // Hide the toast after a few seconds
          setTimeout(() => {
            copyToast1.classList.remove('show');
            copyToast1.classList.add('hide');
          }, 3000); // Show for 3 seconds
        }
      })
      .catch((err) => {
        console.error('Failed to copy the URL: ', err);
      });
  }

  openMenu(value: boolean) {
    this.showMenu = value;
    this.selectedMenu = '';
    if (this.homePage) {
      if (this.showMenu) {
        this.transparent = false;
      } else {
        this.transparent = window.pageYOffset > 70 ? false : true;
      }
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.homePage && typeof window !== 'undefined') {
      if (this.showMenu) {
        this.transparent = false;
      } else {
        this.transparent = window?.pageYOffset > 70 ? false : true;
      }
    } else {
      this.transparent = false;
    }
  }

  closeSigninModel() {
    const modalElement = document.getElementById('sign-in');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
        modalInstance.dispose();
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
      }
    }

    const backdrops = document.getElementsByClassName('modal-backdrop');
    while (backdrops.length > 0) {
      document.body.removeChild(backdrops[0]);
    }
  }

  setIpandLocation() {
    this.datasearch.getIpandLocation().subscribe({
      next: (res) => {
        this.user_ip = res.userip;
        this.address = res.address;
        console.log('🌐 User Info:', res);
      },
      error: (err) => {
        console.error('❌ Error fetching IP/Location:', err);
      },
    });
  }
}
